import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SafeUrl } from '@angular/platform-browser';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subscriber } from 'rxjs';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-convocation-popup',
  templateUrl: './convocation-popup.component.html',
  styleUrls: ['./convocation-popup.component.scss']
})
export class ConvocationPopupComponent implements OnInit {
  photoSignDetailsForm: FormGroup;
  croppedImage: SafeUrl = '';
  submitButton = true;
  updateButton = false;
  photoExt: string;
  singExt: string;
  TODAY_DATE: string;

  lastSearchKeyword: string = '';
  // is_hidephotosign = false;


  readonly PHOTO_MIN_WIDTH = 200;
  readonly PHOTO_MIN_HEIGHT = 230;
  readonly PHOTO_MAX_WIDTH = 500;
  readonly PHOTO_MAX_HEIGHT = 530;
  readonly PHOTO_MAX_SIZE_KB = 50;

  readonly SIGNATURE_MIN_WIDTH = 140;
  readonly SIGNATURE_MIN_HEIGHT = 60;
  readonly SIGNATURE_MAX_WIDTH = 300;
  readonly SIGNATURE_MAX_HEIGHT = 300;
  readonly SIGNATURE_MAX_SIZE_KB = 20;

  INTERNSHIP_MIN_DATE: Date;
  INTERNSHIP_MAX_DATE: Date;
  ACADEMIC_YEAR: string;


  constructor(
    private fb: FormBuilder,
    private dialogRef2: MatDialogRef<ConvocationPopupComponent>,
    private modalPopupService: ModalpopService,
    public umsService: UmsService,
    private spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  StudentPersonalId: any = sessionStorage.getItem('StudentPersonalId');
  studentId = sessionStorage.getItem('StudentRGID');

  imageChangedEvent: Event | null = null;
  dialogRef: MatDialogRef<any>;
  userImage: any;
  errormessage: string;
  signatureImage: any;
  userSign: string;
  fileName: string;
  uploadDoc: any;
  proId: any;
  disabled = false;
  tabs: string;
  displayName: any;
  Course: any;
  College: any;
  isSaving: boolean = false;

  photoActualWidth: number = 0;
  photoActualHeight: number = 0;
  signatureActualWidth: number = 0;
  signatureActualHeight: number = 0;

  ngOnInit(): void {
    const academicDates = this.getAcademicYearDates();
    this.INTERNSHIP_MIN_DATE = academicDates.startDate;
    this.INTERNSHIP_MAX_DATE = academicDates.endDate;
    this.ACADEMIC_YEAR = academicDates.academicYear;
    this.TODAY_DATE = new Date().toISOString().split('T')[0];
    this.StudentPersonalId = this.data.selected.STUDPRN;
    this.photoSignDetailsForm = this.fb.group({
      RgNo: new FormControl(this.StudentPersonalId),
      StuPhoto: new FormControl('', Validators.required),
      StuSignature: new FormControl(''),
      StuABCId2: new FormControl('', [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9]*$')
      ]),
      BirthDate: ['', Validators.required],
      NameInMarathi: new FormControl('', [
        Validators.required,
        Validators.pattern('^[\u0900-\u097F\\s]+$')
      ]),

      AdharNo: new FormControl('', [
        Validators.required,
        Validators.pattern('^[0-9]{12}$')
      ]),

      MobNo: new FormControl('', [
        Validators.required,
        Validators.pattern('^[0-9]{10}$')
      ]),

      Email: new FormControl('', [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$')
      ]),

      InternshipFrom: new FormControl('', [
        this.dateRangeValidator()
      ]),

      InternshipTo: new FormControl('', [
        this.dateRangeValidator()
      ]),

      is_internship: new FormControl(false)
    }, { validators: this.internshipDateValidator() });

    this.photoSignDetailsForm.get('is_internship')?.valueChanges.subscribe((value) => {
      this.toggleInternshipFields(value);
    });

    this.prepopulation();
  }

  toggleInternshipFields(isInternshipCompleted: boolean) {
    const internshipFromControl = this.photoSignDetailsForm.get('InternshipFrom');
    const internshipToControl = this.photoSignDetailsForm.get('InternshipTo');

    if (isInternshipCompleted) {
      internshipFromControl?.enable();
      internshipToControl?.enable();
      internshipFromControl?.setErrors(null);
      internshipToControl?.setErrors(null);
    } else {
      internshipFromControl?.disable();
      internshipToControl?.disable();
      internshipFromControl?.setValue('');
      internshipToControl?.setValue('');
      internshipFromControl?.setErrors(null);
      internshipToControl?.setErrors(null);
    }
  }

  dateRangeValidator() {
    return (control: FormControl) => {
      if (!control.value) return null;

      const selectedDate = new Date(control.value);
      const minDate = new Date('2024-06-01');
      const maxDate = new Date('2025-05-31');

      if (selectedDate < minDate || selectedDate > maxDate) {
        return { invalidDate: true };
      }
      return null;
    };
  }

  internshipDateValidator() {
    return (formGroup: FormGroup) => {
      const from = formGroup.get('InternshipFrom');
      const to = formGroup.get('InternshipTo');
      if (from?.disabled || to?.disabled) {
        from?.setErrors(null);
        to?.setErrors(null);
        return null;
      }

      if (!from || !to || !from.value || !to.value) return null;

      const fromDate = new Date(from.value);
      const toDate = new Date(to.value);

      if (toDate < fromDate) {
        to.setErrors({ toBeforeFrom: true });
        return { invalidDateRange: true };
      } else {
        to.setErrors(null);
      }
      return null;
    };
  }

  fileChangeEvent(event: Event): void {
    this.imageChangedEvent = event;
  }

  validateImageDimensions(file: File, type: 'photo' | 'signature'): Promise<{ isValid: boolean; width: number; height: number; message?: string }> {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const minWidth = type === 'photo' ? this.PHOTO_MIN_WIDTH : this.SIGNATURE_MIN_WIDTH;
        const minHeight = type === 'photo' ? this.PHOTO_MIN_HEIGHT : this.SIGNATURE_MIN_HEIGHT;
        const maxWidth = type === 'photo' ? this.PHOTO_MAX_WIDTH : this.SIGNATURE_MAX_WIDTH;
        const maxHeight = type === 'photo' ? this.PHOTO_MAX_HEIGHT : this.SIGNATURE_MAX_HEIGHT;
        const maxSizeKB = type === 'photo' ? this.PHOTO_MAX_SIZE_KB : this.SIGNATURE_MAX_SIZE_KB;
        const fileSizeKB = file.size / 1024;

        if (type === 'photo') {
          this.photoActualWidth = img.width;
          this.photoActualHeight = img.height;
        } else {
          this.signatureActualWidth = img.width;
          this.signatureActualHeight = img.height;
        }

        if (fileSizeKB > maxSizeKB) {
          resolve({
            isValid: false,
            width: img.width,
            height: img.height,
            message: `File size exceeds limit. Maximum allowed: ${maxSizeKB}KB. Your file: ${fileSizeKB.toFixed(2)}KB.`
          });
          URL.revokeObjectURL(img.src);
          return;
        }

        const widthInRange = img.width >= minWidth && img.width <= maxWidth;
        const heightInRange = img.height >= minHeight && img.height <= maxHeight;

        const isWidthValid = widthInRange && img.height >= minHeight;
        const isHeightValid = heightInRange && img.width >= minWidth;

        let isValid = false;
        let message = '';

        if (isWidthValid || isHeightValid) {
          isValid = true;

          if (img.width === minWidth && img.height === minHeight) {
            message = `Image uploaded successfully`;
          } else if (img.width === maxWidth && img.height === maxHeight) {
            message = `Image uploaded successfully`;
          } else if (img.width === minWidth || img.width === maxWidth) {
            message = `Image uploaded successfully`;
          } else if (img.height === minHeight || img.height === maxHeight) {
            message = `Image uploaded successfully`;
          } else if (widthInRange && heightInRange) {
            message = `Image uploaded successfully`;
          } else if (isWidthValid) {
            message = `Image uploaded successfully `;
          } else if (isHeightValid) {
            message = ` Image uploaded successfully `;
          }
        } else {
          isValid = false;

          if (img.width < minWidth) {
            message = `Width is too small. Minimum required: ${minWidth}px.`;
          } else if (img.width > maxWidth) {
            message = `Width is too large. Maximum allowed: ${maxWidth}px.`;
          } else if (img.height < minHeight) {
            message = `Height is too small. Minimum required: ${minHeight}px.`;
          } else if (img.height > maxHeight) {
            message = `Height is too large. Maximum allowed: ${maxHeight}px.`;
          }
        }

        resolve({
          isValid,
          width: img.width,
          height: img.height,
          message
        });

        URL.revokeObjectURL(img.src);
      };
      img.onerror = () => {
        resolve({ isValid: false, width: 0, height: 0, message: 'Failed to load image' });
        URL.revokeObjectURL(img.src);
      };
      img.src = URL.createObjectURL(file);
    });
  }

  private showErrorDialog(message: string): void {
    const data = {
      message: message,
      title: 'Information',
      icon: 'fas fa-close'
    };
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    this.dialogRef.afterClosed().subscribe(() => { });
  }

  private showInfoDialog(message: string): void {
    const data = {
      message: message,
      title: 'Information',
      icon: 'fas fa-info-circle'
    };
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  }

  onChange1($event: Event) {
    const fileInput = $event.target as HTMLInputElement;
    const file = fileInput.files?.[0];
    if (!file) return;

    const fileName = file.name;
    this.fileName = fileName;
    this.photoExt = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
    if (!['jpg', 'jpeg'].includes(this.photoExt)) {
      this.showErrorDialog('File not supported. Please upload JPG or JPEG image only for photo.');
      return;
    }
    this.photoActualWidth = 0;
    this.photoActualHeight = 0;
    this.validateImageDimensions(file, 'photo').then(({ isValid, width, height, message }) => {
      if (!isValid) {
        this.showErrorDialog(message);
        return;
      }

      if (message) {
        this.showInfoDialog(message);
      }

      this.convertToBase641(file);
    });
  }

  onChangeSign($event: Event) {
    const file = ($event.target as HTMLInputElement).files[0];
    if (!file) return;

    const fileName = file.name;
    this.fileName = fileName;
    this.singExt = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
    if (!['jpg', 'jpeg'].includes(this.singExt)) {
      this.showErrorDialog('File not supported. Please upload JPG or JPEG image only for signature.');
      return;
    }
    this.signatureActualWidth = 0;
    this.signatureActualHeight = 0;
    this.validateImageDimensions(file, 'signature').then(({ isValid, width, height, message }) => {
      if (!isValid) {
        this.showErrorDialog(message);
        return;
      }

      if (message) {
        this.showInfoDialog(message);
      }

      this.convertToBase64Sign(file);
    });
  }

  convertToBase641(file: File) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile1(file, subscriber);
    });

    observable.subscribe((base64Data: string) => {
      this.userImage = base64Data;
      this.photoSignDetailsForm.get('StuPhoto')?.setValue(base64Data);

      if (!this.userImage) {
        this.photoSignDetailsForm.get('StuPhoto')?.markAsTouched();
      } else {
        this.photoSignDetailsForm.get('StuPhoto')?.markAsUntouched();
      }
    });
  }

  readFile1(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }

  convertToBase64Sign(file: File) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFileSign(file, subscriber);
    });

    observable.subscribe((base64Data: string) => {
      this.signatureImage = base64Data;
      this.photoSignDetailsForm.get('StuSignature')?.setValue(base64Data);

      if (!this.signatureImage) {
        this.photoSignDetailsForm.get('StuSignature')?.markAsTouched();
      } else {
        this.photoSignDetailsForm.get('StuSignature')?.markAsUntouched();
      }
    });
  }

  readFileSign(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }

  prepopulation() {
    if (this.data.key == 'view' && this.data.key === 'view') {
      this.updateButton = false;
    } else {
      this.updateButton = true;
    }
    this.spinner.show();

    this.getStudentDetails();
    // let data = {}
    // this.getFiles(data);
  }

  getStudentDetails() {
    let payload = {
      // StuId: 0,  
      RgNo: this.data.selected.STUDPRN,
      // CgCode: '',
      // CoCode: '',
      // Flag: '', 
      PageNumber: 1,
      PageSize: 10
    };

    this.umsService.convocationData(payload).subscribe((res) => {
      if (res?.data?.[0]) {
        const studentData = res.data[0];

        const isInternshipCompleted = studentData.HAVEINTERN === 'Y'

        this.photoSignDetailsForm.patchValue({
          StuABCId2: studentData.ABC_ID || '',
          RgNo: studentData.STUDPRN,
          BirthDate: studentData.DOB ? this.formatDateForFrontend(studentData.DOB) : '',
          NameInMarathi: studentData.STUDNMAR || '',
          AdharNo: studentData.AADHAR_NO || '',
          MobNo: studentData.MOBILE_NO || '',
          Email: studentData.EMAIL_ID || '',
          InternshipFrom: studentData.INTERNSHIP_FROM ? this.formatDateForFrontend(studentData.INTERNSHIP_FROM) : '',
          InternshipTo: studentData.INTERNSHIP_TO ? this.formatDateForFrontend(studentData.INTERNSHIP_TO) : '',
          is_internship: isInternshipCompleted
        });

        // this.is_hidephotosign = studentData.is_hidephotosign;
        this.toggleInternshipFields(isInternshipCompleted);
        this.getFiles({});
      }
      this.spinner.hide();
    }, (error) => {
      console.log('Error fetching student details:', error);
      this.spinner.hide();
    });
  }

  getFiles(data: any) {
    this.spinner.show();
    let payload = {};
    this.StudentPersonalId = this.data.selected;
    payload['RgNo'] = this.photoSignDetailsForm.value.RgNo;
    payload['fileNames'] = [
      this.StudentPersonalId.PHOTO ?? '',
      this.StudentPersonalId.SIGN ?? ''
    ];
    this.umsService.getFilesDetailscon(payload).subscribe((res) => {
      this.spinner.hide();
      const files = res.files || [];
      const photoFile = files.find((f: any) =>
        f.fileName?.toLowerCase().includes('photo') || f.fileName?.toLowerCase().includes('stu')
      );
      const signFile = files.find((f: any) =>
        f.fileName?.toLowerCase().includes('sign') || f.fileName?.toLowerCase().includes('signature')
      );

      this.userImage = photoFile?.base64Data || '';
      this.signatureImage = signFile?.base64Data || '';
      this.photoSignDetailsForm.patchValue({
        StuPhoto: new FormControl(this.userImage, Validators.required),
        StuSignature: new FormControl(this.signatureImage),
      });
    });
  }

  updateCheck() {
    const isInternshipCompleted = this.photoSignDetailsForm.get('is_internship')?.value;

    if (!isInternshipCompleted) {
      this.photoSignDetailsForm.patchValue({
        InternshipFrom: '',
        InternshipTo: ''
      });
    }
    if (this.photoSignDetailsForm.invalid) {
      this.photoSignDetailsForm.markAllAsTouched();

      if (this.photoSignDetailsForm.get('InternshipTo')?.errors?.toBeforeFrom) {
        this.showErrorDialog('Internship To date must be after Internship From date');
      }
      return;
    }

    if (!this.userImage) {
      this.photoSignDetailsForm.get('StuPhoto')?.markAsTouched();
      // if (!this.signatureImage) {
      //   this.photoSignDetailsForm.get('StuSignature')?.markAsTouched();
      // }
      this.showErrorDialog('Photo required');
      return;
    }


    if (isInternshipCompleted) {
      const internshipFrom = this.photoSignDetailsForm.get('InternshipFrom')?.value;
      const internshipTo = this.photoSignDetailsForm.get('InternshipTo')?.value;

      if ((internshipFrom && !internshipTo) || (!internshipFrom && internshipTo)) {
        this.showErrorDialog('Both Internship From and To dates must be provided together');
        return;
      }
    }
    this.UpdatePhotoSign();
    this.saveFiles();
    this.updateAdditionalDetails();
  }

  isInvalid(controlName: string, errorType?: string): boolean {
    const control = this.photoSignDetailsForm.get(controlName);
    if (!control) return false;

    if (errorType) {
      return control.touched && control.hasError(errorType);
    }

    return control.touched && control.invalid;
  }


  UpdatePhotoSign() {
    this.spinner.show();
    let payload = this.photoSignDetailsForm.value;
    payload.StuId = parseInt(payload.StuId);
    payload.RgNo = parseInt(payload.RgNo);
    payload.StuPhoto = "photo." + this.photoExt;
    // payload.StuSignature = "sign." + this.singExt;

    if (this.signatureImage && this.singExt) {
      payload.StuSignature = "sign." + this.singExt;
    } else {
      payload.StuSignature = ''; // Or null
    }
    payload['StuProfId'] = this.proId;
    payload.LoginId = parseInt(sessionStorage.getItem('StudentRGID'));
  }

  submitCheck() {
    if (!this.userImage) {
      this.photoSignDetailsForm.get('StuPhoto')?.markAsTouched();
      this.showErrorDialog('Photo is required');
      return;
    }
    this.save();
    this.saveFiles();

  }

  save() {
    this.isSaving = true;
    this.submitButton = true;
    this.updateButton = false;
    const payload = this.photoSignDetailsForm.value;
    payload.StuId = parseInt(payload.StuId);
    payload.RgNo = parseInt(payload.RgNo);
    payload.StuPhoto = "photo." + this.photoExt;
    if (this.signatureImage && this.singExt) {
      payload.StuSignature = "sign." + this.singExt;
    } else {
      payload.StuSignature = '';
    }

    payload.LoginId = parseInt(sessionStorage.getItem('StudentRGID'));
  }

  saveFiles() {
    const formValue = this.photoSignDetailsForm.getRawValue();
    const files = [];
    if (this.userImage) {
      files.push({
        fileName: "photo." + this.photoExt,
        base64Data: this.userImage
      });
    }
    if (this.signatureImage && this.singExt) {
      files.push({
        fileName: "sign." + this.singExt,
        base64Data: this.signatureImage
      });
    }
    const payload = {
      RgNo: String(formValue.RgNo),
      files: files
    };


    this.umsService.saveFilesDetailscon(payload).subscribe(
      res => {
        if (res.status) {
          this.spinner.hide();
        } else {
          this.isSaving = false;
          this.spinner.hide();
        }
      },
      (error: HttpErrorResponse) => {
        this.isSaving = false;
        this.spinner.hide();
      }
    );
  }

  updateAdditionalDetails() {
    const formValue = this.photoSignDetailsForm.getRawValue();
    const payload = {
      STUDPRN: formValue.RgNo ? String(formValue.RgNo) : '',
      DOB: formValue.BirthDate
        ? this.formatDateForAPI(formValue.BirthDate)
        : null,
      STUDNMAR: formValue.NameInMarathi ?? '',
      INTERNSHIP_FROM:
        formValue.is_internship && formValue.InternshipFrom
          ? this.formatDateForAPI(formValue.InternshipFrom)
          : null,

      INTERNSHIP_TO:
        formValue.is_internship && formValue.InternshipTo
          ? this.formatDateForAPI(formValue.InternshipTo)
          : null,

      ABC_ID: formValue.StuABCId2 || null,

      AADHAR_NO: formValue.AdharNo || null,

      MOBILE_NO: formValue.MobNo || null,

      EMAIL_ID: formValue.Email || null
    };


    this.spinner.show();

    this.umsService.updateCon(payload).subscribe(res => {
      if (res.status) {
        this.saveFiles();

        let data = {
          message: "All details updated successfully!",
          title: 'Information',
          icon: 'fas fa-check'
        };

        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

        this.dialogRef.afterClosed().subscribe(() => {
          this.dialogRef2.close({
            status: 'updated',
            source: this.data?.source || 'all'
          });
        });

      } else {
        this.showErrorDialog(res.message || "Failed to update details");
      }
      this.spinner.hide();
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.showErrorDialog("Error updating details. Please try again.");
    });
  }
  private formatDateForAPI(date: any): string {
    if (!date) return '';

    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }
  getAcademicYearDates() {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();

    let startYear, endYear;

    if (currentMonth >= 5) {
      startYear = currentYear;
      endYear = currentYear + 1;
    } else { // Jan to Apr
      startYear = currentYear - 2;
      endYear = currentYear - 1;
    }

    const startDate = new Date(startYear, 5, 1);
    const endDate = new Date(endYear, 4, 31);

    return {
      startDate,
      endDate,
      academicYear: `${startYear}-${endYear}`
    };
  }


  private formatDateForFrontend(dateStr: string): string {
    if (!dateStr) return '';

    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

}